"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterBeds = exports.getCustomExcludedRooms = exports.getCustomAccommodationFilters = exports.getAccommodationTypes = exports.setAccessibleOnly = exports.sortOffersByPrice = exports.sortOffers = exports.sortBedsByPrice = exports.sortBeds = exports.setLowestPriceInfo = exports.getRooms = exports.getRoomsData = void 0;
const RoomsData_1 = require("../../types/booking/RoomsData");
const helpers_1 = require("../helpers");
const offerNotAvailableErrorKey = 'There are no rooms available for the selected offer on your preferred dates. Please select from the list of rooms below to see the available offers and rates.';
const roomNotAvailableErrorKey = 'Your preferred room type is not available for your selected dates. Please select from the list of available rooms & offers below.';
const noSearchResultsErrorKey = 'bk24.noavailablerooms';
const getRoomsData = (input) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
    try {
        if (!input) {
            throw new helpers_1.ContentError('Invalid parameters - input required');
        }
        if (!input.oj) {
            throw new helpers_1.OjError('Invalid parameters - availability response required');
        }
        if (!input.content) {
            throw new helpers_1.ContentError('Invalid parameters - content required');
        }
        const { accommodations: rooms, availabilityBookingMessages, exchangeRates: currencies, globalSettings, offers, property, taxes: propertyTaxes, } = input.content;
        if (!rooms) {
            throw new helpers_1.ContentError('Invalid parameters - content.accommodations required');
        }
        if (!offers) {
            throw new helpers_1.ContentError('Invalid parameters - content.offers required');
        }
        if (!property) {
            throw new helpers_1.ContentError('Invalid parameters - content.property required');
        }
        const usAccessibility = property.enCountry === 'U.S.A.' || property.optInUsAccessibleRooms === true;
        const selectedOfferCode = input.ratePlanCode;
        const selectedRoomCodes = input.roomOwsCodes ? input.roomOwsCodes.split(',') : undefined;
        let accessibleRooms = !!((_a = input.roomsState) === null || _a === void 0 ? void 0 : _a.accessible);
        let selectedOfferAvailable = false;
        let selectedRoomAvailable = false;
        let selectedRoomIsAccessible = false;
        const error = helpers_1.getError({
            language: input.language,
            employee: !!input.employee,
            propertyMetaData: property,
            supplierErrors: (_b = input.oj) === null || _b === void 0 ? void 0 : _b.supplierErrors,
            apiErrors: (_c = input.oj) === null || _c === void 0 ? void 0 : _c.apiErrors,
        });
        const roomsData = {
            propertyName: '',
            searchResults: [],
            bookDirectOffers: [],
            bookingMessages: [],
            disclaimer: '',
            webChat: {
                enabled: false,
            },
        };
        roomsData.propertyName = helpers_1.formatBeverlyWilshire(property.shortName);
        roomsData.disclaimer = helpers_1.formatBeverlyWilshire(property.propertyDisclaimer);
        if (availabilityBookingMessages) {
            roomsData.bookingMessages =
                ((_d = availabilityBookingMessages.messages) === null || _d === void 0 ? void 0 : _d.map(message => {
                    return {
                        title: message.title,
                        body: helpers_1.formatBeverlyWilshire(message.body),
                    };
                })) || [];
        }
        if (!input.pp && !input.employee && property.globalTollFreeLink) {
            roomsData.tollFreeNumbers = {
                url: property.globalTollFreeLink,
                textDictKey: helpers_1.setDictionaryKey('Toll Free Numbers By Country'),
            };
        }
        const webUrlEn = property.urlWeb
            ? property.urlWeb.replace(/\/([a-z_]{2}(_[a-z]{2,4})?)\//, '/en/')
            : '';
        if (input.pp) {
            roomsData.contactUs = {
                url: '/contact/property_key_contacts/',
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        else if (webUrlEn) {
            roomsData.contactUs = {
                url: `${webUrlEn}/contact-us/`,
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        roomsData.webChat = { enabled: false };
        if (property.webChatConfig) {
            const webChat = ((_e = property.webChatConfig['chatinrbf-bookingflow__step-2']) === null || _e === void 0 ? void 0 : _e.enabled) ? property.webChatConfig['chatinrbf-bookingflow__step-2']
                : property.webChatConfig['chatinrbf-bookingflow'];
            if (webChat && webChat.enabled) {
                roomsData.webChat = {
                    enabled: webChat.enabled && !input.employee && !input.pp,
                    id: webChat.id,
                    integrationId: webChat.integrationId,
                    propertyName: property.landingPagePropertyName,
                    propertyCode: property.owsCode,
                };
                if ((_g = (_f = property.upcomingTrip) === null || _f === void 0 ? void 0 : _f.desktopImage) === null || _g === void 0 ? void 0 : _g.croppedPath) {
                    roomsData.webChat.propertyImage = {
                        path: (_j = (_h = property.upcomingTrip) === null || _h === void 0 ? void 0 : _h.desktopImage) === null || _j === void 0 ? void 0 : _j.croppedPath,
                    };
                }
            }
        }
        if (error.messageDictKey.key) {
            roomsData.bookingError = {
                labelDictKey: error.labelDictKey,
                messageDictKey: error.messageDictKey,
                descriptionDictKey: error.descriptionDictKey,
                contactReservations: error.contactReservations,
                field: error.field,
            };
        }
        if (!((_k = input.oj.results) === null || _k === void 0 ? void 0 : _k.hotelOptions) || !input.oj.results.hotelOptions.length) {
            throw new helpers_1.OjError('Unexpected OJ Response - No hotelOptions');
        }
        const hotelOptions = (_l = input.oj.results) === null || _l === void 0 ? void 0 : _l.hotelOptions[0];
        if (!((_m = hotelOptions.roomRates) === null || _m === void 0 ? void 0 : _m.length)) {
            throw new helpers_1.OjError('Unexpected OJ Response - No roomRates');
        }
        if (!hotelOptions.duration) {
            throw new helpers_1.OjError('Unexpected OJ Response - No Duration');
        }
        const { allInPricing = false } = hotelOptions;
        const defaultPriceLabel = allInPricing ? helpers_1.priceLabelAllInPricing : helpers_1.priceLabelAveragePerNight;
        const inventoryUsed = (_p = (_o = input.roomsState) === null || _o === void 0 ? void 0 : _o.roomSelections) === null || _p === void 0 ? void 0 : _p.reduce((used, code) => {
            if (code) {
                let usedCount = 1;
                if (used[code]) {
                    usedCount = used[code] + 1;
                }
                return Object.assign(Object.assign({}, used), { [code]: usedCount });
            }
            return used;
        }, {});
        const roomIndex = ((_q = input.roomsState) === null || _q === void 0 ? void 0 : _q.roomSelections) ? ((_r = input.roomsState) === null || _r === void 0 ? void 0 : _r.roomSelections.length) + 1
            : 1;
        const availableOfferCodes = [];
        const resultIds = (_s = hotelOptions.roomOptions) === null || _s === void 0 ? void 0 : _s.reduce((results, roomOption) => {
            var _a;
            if (roomOption.roomIndex !== roomIndex) {
                return results;
            }
            const roomTypeIds = (_a = roomOption.roomTypeIds) === null || _a === void 0 ? void 0 : _a.reduce((roomTypes, roomTypeId) => {
                var _a;
                const roomRateIds = (_a = roomTypeId.roomRateIds) === null || _a === void 0 ? void 0 : _a.reduce((roomRates, roomRate) => {
                    if (roomRate.id && roomRate.roomRateId) {
                        const roomRateId = roomRate.roomRateId.split('.');
                        if (roomRateId.length === 4 && roomRateId[1]) {
                            if (!availableOfferCodes.includes(roomRateId[1])) {
                                availableOfferCodes.push(roomRateId[1]);
                            }
                        }
                        return Object.assign(Object.assign({}, roomRates), { [roomRate.roomRateId]: roomRate.id });
                    }
                    return roomRates;
                }, {});
                return Object.assign(Object.assign({}, roomTypes), roomRateIds);
            }, {});
            return Object.assign(Object.assign({}, results), roomTypeIds);
        }, {});
        if (!resultIds) {
            throw new helpers_1.OjError('Unexpected OJ Response - No roomRateIds');
        }
        const bedsByOws = rooms.bookableAccommodations.reduce((bookableRooms, room) => {
            const bedTypes = room.sleepingArrangements.reduce((bookableBeds, bed) => {
                if (!bed.owsCode) {
                    return bookableBeds;
                }
                const bedWithName = Object.assign(Object.assign({}, bed), { uniqueName: room.uniqueName });
                return Object.assign(Object.assign({}, bookableBeds), { [bed.owsCode]: bedWithName });
            }, {});
            return Object.assign(Object.assign({}, bookableRooms), bedTypes);
        }, {});
        const offersByOws = offers.bookableOffers.reduce((bookableOffers, offer) => {
            if (!offer.owsCode) {
                return bookableOffers;
            }
            if (input.pp && offer.ppCode && availableOfferCodes.includes(offer.ppCode)) {
                return bookableOffers;
            }
            if (input.pp && offer.orsCode === 'FSHBNB' && !offer.ppCode) {
                return bookableOffers;
            }
            return Object.assign(Object.assign({}, bookableOffers), { [offer.owsCode]: offer });
        }, {});
        const offersByPp = offers.bookableOffers.reduce((bookableOffers, offer) => {
            if (!offer.ppCode) {
                return bookableOffers;
            }
            return Object.assign(Object.assign({}, bookableOffers), { [offer.ppCode]: offer });
        }, {});
        let promoOffer;
        let employeeCompBooking = false;
        let employeeCompResortFees;
        if (input.promoCode) {
            promoOffer = {
                title: '',
                urlWeb: '',
                urlApi: '',
                id: '',
                inclusionsArray: [],
                inclusions: [],
                hidden: false,
                conditions: [],
            };
            employeeCompBooking = helpers_1.isEmployeeComplimentaryRate(input.promoCode);
            if (employeeCompBooking && !allInPricing) {
                const empRoomRate = ((_t = hotelOptions.roomRates) === null || _t === void 0 ? void 0 : _t[0]) || {};
                (_x = (_w = (_v = (_u = empRoomRate.prices) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.prepay) === null || _w === void 0 ? void 0 : _w.taxesFeesCharges) === null || _x === void 0 ? void 0 : _x.forEach(tax => {
                    if (tax.cash) {
                        const propertyTax = propertyTaxes === null || propertyTaxes === void 0 ? void 0 : propertyTaxes.taxes.find(taxItem => taxItem.taxID === tax.code);
                        if (!propertyTax || !propertyTax.isPercentage) {
                            if (employeeCompResortFees) {
                                employeeCompResortFees.amount += tax.cash.amount;
                            }
                            else {
                                employeeCompResortFees = Object.assign({}, tax.cash);
                            }
                        }
                    }
                });
            }
        }
        let availableBeds = [];
        (_y = hotelOptions.roomRates) === null || _y === void 0 ? void 0 : _y.forEach(roomRate => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const roomRateId = roomRate.roomRateId.split('.');
            if (roomRateId.length === 4) {
                const offerCode = roomRateId[1];
                const roomCode = roomRateId[2];
                const availableBed = availableBeds.find(bed => bed.owsCode === roomCode);
                const resultId = resultIds[roomRate.roomRateId];
                const priceId = ((_a = roomRate.prices) === null || _a === void 0 ? void 0 : _a.length) && roomRate.prices[0].id;
                let ojPrice = ((_b = roomRate.prices) === null || _b === void 0 ? void 0 : _b.length) && roomRate.prices[0].total.cash;
                const resortFees = employeeCompBooking
                    ? employeeCompResortFees
                    : !allInPricing && ((_c = roomRate.prices) === null || _c === void 0 ? void 0 : _c.length) && ((_e = (_d = roomRate.prices[0].prepay) === null || _d === void 0 ? void 0 : _d.taxesFeesChargesTotal) === null || _e === void 0 ? void 0 : _e.cash);
                const foundBed = bedsByOws[roomCode];
                let foundOffer;
                let ppOffer = false;
                if (input.promoCode) {
                    if (input.promoCode === offerCode) {
                        const employeeRateTitle = helpers_1.getEmployeeRateTitle(input.promoCode);
                        foundOffer = Object.assign(Object.assign({}, promoOffer), { title: employeeRateTitle || helpers_1.fixPromoTitle(roomRate.ratePlanTitle) || '' });
                    }
                }
                else if (input.pp) {
                    foundOffer = offersByPp[offerCode];
                    if (foundOffer) {
                        ppOffer = true;
                    }
                    else {
                        foundOffer = offersByOws[offerCode];
                    }
                }
                else {
                    foundOffer = offersByOws[offerCode];
                    if (foundOffer && foundOffer.localMarketOnly) {
                        if (!input.geoIpCountryCode ||
                            !foundOffer.localMarketCountryCode ||
                            input.geoIpCountryCode !== foundOffer.localMarketCountryCode) {
                            foundOffer = undefined;
                        }
                    }
                }
                let hasInventory = true;
                if (foundBed && inventoryUsed && inventoryUsed[roomCode]) {
                    const remainingUnits = roomRate.remainingUnits
                        ? parseInt(roomRate.remainingUnits, 10) || 0
                        : 0;
                    if (inventoryUsed[roomCode] >= remainingUnits) {
                        hasInventory = false;
                    }
                }
                if (foundBed &&
                    foundOffer &&
                    !foundOffer.hidden &&
                    resultId &&
                    priceId &&
                    ojPrice &&
                    hasInventory) {
                    if (employeeCompBooking) {
                        if (employeeCompResortFees) {
                            ojPrice = {
                                amount: employeeCompResortFees.amount,
                                currencyCode: employeeCompResortFees.currencyCode,
                            };
                        }
                        else {
                            ojPrice = helpers_1.convertEmployeePrice(ojPrice, input.promoCode);
                        }
                    }
                    const availableOffer = Object.assign(Object.assign({}, foundOffer), { resultId,
                        priceId, price: helpers_1.convertCurrency({
                            amount: ojPrice.amount / (hotelOptions.duration || 1),
                            currencyCode: ojPrice.currencyCode,
                        }, currencies, (_f = input.roomsState) === null || _f === void 0 ? void 0 : _f.currency), resortFees: resortFees
                            ? helpers_1.convertCurrency({
                                amount: resortFees.amount,
                                currencyCode: resortFees.currencyCode,
                            }, currencies, (_g = input.roomsState) === null || _g === void 0 ? void 0 : _g.currency)
                            : undefined, ppOffer, priceLabel: getPriceLabel(allInPricing, input.geoIpCountryCode, globalSettings === null || globalSettings === void 0 ? void 0 : globalSettings.resortFeesPricingCountries, propertyTaxes, (_j = (_h = roomRate.prices) === null || _h === void 0 ? void 0 : _h[0].prepay) === null || _j === void 0 ? void 0 : _j.taxesFeesCharges) });
                    if (availableBed) {
                        (_k = availableBed.offers) === null || _k === void 0 ? void 0 : _k.push(availableOffer);
                    }
                    else {
                        availableBeds.push(Object.assign(Object.assign({}, foundBed), { offers: [availableOffer], accessibleOnly: false, priceLabel: defaultPriceLabel }));
                    }
                    if (selectedRoomCodes &&
                        foundBed.owsCode &&
                        selectedRoomCodes.includes(foundBed.owsCode)) {
                        selectedRoomAvailable = true;
                        if (foundBed.isAccessible) {
                            selectedRoomIsAccessible = true;
                        }
                    }
                    if (selectedOfferCode) {
                        if (input.pp && foundOffer.ppCode === selectedOfferCode) {
                            selectedOfferAvailable = true;
                        }
                        else if (foundOffer.owsCode === selectedOfferCode) {
                            selectedOfferAvailable = true;
                        }
                    }
                }
            }
        });
        if (selectedRoomIsAccessible &&
            usAccessibility &&
            !accessibleRooms &&
            !((_z = input.roomsState) === null || _z === void 0 ? void 0 : _z.hasInteractedWithAccessiblityOption) &&
            !((_0 = input.roomsState) === null || _0 === void 0 ? void 0 : _0.suppressRoomListingErrors) &&
            !((_2 = (_1 = input.roomsState) === null || _1 === void 0 ? void 0 : _1.roomSelections) === null || _2 === void 0 ? void 0 : _2.length)) {
            accessibleRooms = true;
            roomsData.state = {
                accessible: true,
            };
        }
        availableBeds = setLowestPriceInfo(availableBeds);
        availableBeds = sortBeds(availableBeds, false, selectedRoomCodes, selectedOfferCode);
        const hasBookableAvailableBeds = !!availableBeds.length;
        rooms.bookableAccommodations.forEach(room => {
            room.sleepingArrangements.forEach(bed => {
                if (!bed.owsCode) {
                    if (!filterBeds(availableBeds, { roomPath: bed.roomPath, bookDirect: false })
                        .length) {
                        availableBeds.push(Object.assign(Object.assign({}, bed), { uniqueName: room.uniqueName, accessibleOnly: false, priceLabel: defaultPriceLabel }));
                    }
                }
            });
        });
        if (usAccessibility) {
            availableBeds = setAccessibleOnly(availableBeds);
        }
        const accommodationTypes = getAccommodationTypes(availableBeds, property, selectedOfferCode, selectedRoomCodes);
        accommodationTypes.forEach(type => {
            var _a, _b, _c, _d, _e, _f;
            let filters = {
                accommodationType: type,
            };
            if (accessibleRooms) {
                filters.accessible = true;
            }
            else if (usAccessibility) {
                filters.accessibleOnly = false;
            }
            if (!!input.promoCode || input.pp) {
                filters.bookDirect = false;
            }
            filters = getCustomAccommodationFilters(property, filters);
            filters.bookDirect = false;
            const filteredBookable = filterBeds(availableBeds, filters);
            const stateSort = ((_a = input.roomsState) === null || _a === void 0 ? void 0 : _a.sort) === RoomsData_1.RoomsData.SortOption.HighToLow ||
                ((_b = input.roomsState) === null || _b === void 0 ? void 0 : _b.sort) === RoomsData_1.RoomsData.SortOption.LowToHigh;
            const pinnedRooms = !!filters.customAccommodations && !!filters.customAccommodations.pinnedRooms
                ? filters.customAccommodations.pinnedRooms
                : [];
            const category = {
                name: type,
                rooms: [],
            };
            if (filteredBookable.length) {
                let reverseSortRooms = property.sortHighToLow === true;
                let reverseSortOffers = property.sortHighToLow === true;
                if (stateSort) {
                    reverseSortRooms = ((_c = input.roomsState) === null || _c === void 0 ? void 0 : _c.sort) === RoomsData_1.RoomsData.SortOption.HighToLow;
                    reverseSortOffers = ((_d = input.roomsState) === null || _d === void 0 ? void 0 : _d.sort) === RoomsData_1.RoomsData.SortOption.HighToLow;
                }
                else {
                    const customAccommodationType = (_f = (_e = property.customDisplayStep2) === null || _e === void 0 ? void 0 : _e.categories) === null || _f === void 0 ? void 0 : _f.find(customType => customType.title === type);
                    if (customAccommodationType) {
                        reverseSortRooms = customAccommodationType.sortRoomsHighToLow;
                        reverseSortOffers = customAccommodationType.sortOffersHighToLow;
                    }
                }
                const sortedBookable = sortBeds(filteredBookable, reverseSortRooms, selectedRoomCodes, selectedOfferCode, stateSort ? [] : pinnedRooms).reduce((sortedBeds, bed) => {
                    var _a;
                    if ((_a = bed.offers) === null || _a === void 0 ? void 0 : _a.length) {
                        sortedBeds.push(Object.assign(Object.assign({}, bed), { offers: sortOffers(bed.offers, reverseSortOffers, input.pp, selectedOfferCode) || [] }));
                    }
                    else {
                        sortedBeds.push(bed);
                    }
                    return sortedBeds;
                }, []);
                category.rooms = category.rooms.concat(getRooms(sortedBookable, property, input.pp, allInPricing));
            }
            if (!input.promoCode && !input.pp) {
                filters.bookDirect = true;
                const filteredOnRequest = filterBeds(availableBeds, filters);
                if (filteredOnRequest.length) {
                    const sortedOnRequest = sortBeds(filteredOnRequest, false, [], '', pinnedRooms);
                    category.rooms = category.rooms.concat(getRooms(sortedOnRequest, property, input.pp, allInPricing));
                }
            }
            if (category.rooms.length) {
                roomsData.searchResults.push(category);
            }
        });
        if (input.promoCode && !roomsData.searchResults.length && !hasBookableAvailableBeds) {
            const _4 = helpers_1.getError({
                language: input.language,
                employee: !!input.employee,
                propertyMetaData: property,
                supplierErrors: [
                    {
                        errorCode: 'E0301',
                    },
                ],
            }), { errorCode, errorMessage } = _4, promoError = __rest(_4, ["errorCode", "errorMessage"]);
            roomsData.bookingError = promoError;
        }
        else {
            if (!((_3 = input.roomsState) === null || _3 === void 0 ? void 0 : _3.suppressRoomListingErrors) &&
                ((selectedOfferCode && !selectedOfferAvailable) ||
                    (selectedRoomCodes && !selectedRoomAvailable))) {
                roomsData.availabilityErrors = [];
                if (selectedOfferCode && !selectedOfferAvailable) {
                    roomsData.availabilityErrors.push({
                        messageDictKey: helpers_1.setDictionaryKey(offerNotAvailableErrorKey),
                    });
                }
                if (selectedRoomCodes && !selectedRoomAvailable) {
                    roomsData.availabilityErrors.push({
                        messageDictKey: helpers_1.setDictionaryKey(roomNotAvailableErrorKey),
                    });
                }
            }
            if (!roomsData.searchResults.length) {
                if (roomsData.availabilityErrors) {
                    roomsData.availabilityErrors.push({
                        messageDictKey: helpers_1.setDictionaryKey(noSearchResultsErrorKey),
                    });
                }
                else {
                    roomsData.availabilityErrors = [
                        {
                            messageDictKey: helpers_1.setDictionaryKey(noSearchResultsErrorKey),
                        },
                    ];
                }
            }
        }
        return roomsData;
    }
    catch (err) {
        if (err instanceof helpers_1.ContentError || err instanceof helpers_1.OjError) {
            return { error: err };
        }
        throw err;
    }
};
exports.getRoomsData = getRoomsData;
const getRooms = (beds, property, ppMode, allInPricing) => {
    const seenRooms = [];
    const rooms = [];
    beds.forEach(bed => {
        if (!seenRooms.includes(bed.roomPath)) {
            seenRooms.push(bed.roomPath);
            const roomBeds = beds.filter(filterBed => filterBed.roomPath === bed.roomPath);
            const bedTypes = [];
            const bedOptions = [];
            let lowestRate;
            let lowestRateFees;
            let priceLabel = '';
            roomBeds.forEach(bedType => {
                var _a, _b, _c, _d, _e, _f;
                let bedTypeOffers = [];
                if ((_a = bedType.offers) === null || _a === void 0 ? void 0 : _a.length) {
                    bedTypeOffers = (_b = bedType.offers) === null || _b === void 0 ? void 0 : _b.reduce((offers, offer) => {
                        offers.push(helpers_1.mapRoomsDataOfferContent(offer, property, offer.price, offer.resortFees, offer.ppOffer, allInPricing));
                        return offers;
                    }, []);
                }
                if (((_d = (_c = bedType.lowestPriceInfo) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.withoutDecimal) ||
                    ((_f = (_e = bedType.lowestPriceInfo) === null || _e === void 0 ? void 0 : _e.amount) === null || _f === void 0 ? void 0 : _f.withoutDecimal) === 0) {
                    if (!lowestRate ||
                        bedType.lowestPriceInfo.amount.withoutDecimal <
                            lowestRate.amount.withoutDecimal) {
                        lowestRate = Object.assign({}, bedType.lowestPriceInfo);
                        lowestRateFees = bedType.resortFees
                            ? Object.assign({}, bedType.resortFees) : undefined;
                        priceLabel = bedType.priceLabel;
                    }
                }
                if (bedType.bedTypeDescription &&
                    !bedOptions.includes(bedType.bedTypeDescription)) {
                    bedOptions.push(bedType.bedTypeDescription);
                }
                bedTypes.push({
                    owsCode: bedType.owsCode || '',
                    orsCode: bedType.orsCode || '',
                    accessible: bedType.isAccessible === 'true',
                    accessibleOnly: bedType.accessibleOnly,
                    description: bedType.bedTypeDescription || '',
                    offers: bedTypeOffers,
                });
            });
            if (bedTypes.length) {
                rooms.push(helpers_1.mapRoomsDataRoomContent(bed, property, bedOptions, bedTypes, lowestRate, lowestRateFees, priceLabel, allInPricing));
            }
        }
    });
    return rooms;
};
exports.getRooms = getRooms;
const setLowestPriceInfo = (beds) => {
    return beds.map(bed => {
        var _a, _b;
        if ((_a = bed.offers) === null || _a === void 0 ? void 0 : _a.length) {
            const lowestPriceInfo = (_b = bed.offers) === null || _b === void 0 ? void 0 : _b.reduce((lowestPrice, offer) => {
                var _a;
                if (!((_a = lowestPrice.price) === null || _a === void 0 ? void 0 : _a.amount) ||
                    offer.price.amount.withoutDecimal < lowestPrice.price.amount.withoutDecimal) {
                    return {
                        price: offer.price,
                        fees: offer.resortFees,
                        priceLabel: offer.priceLabel,
                    };
                }
                return lowestPrice;
            }, { price: {}, priceLabel: '' });
            return Object.assign(Object.assign({}, bed), { lowestPriceInfo: lowestPriceInfo.price, resortFees: lowestPriceInfo.fees, priceLabel: lowestPriceInfo.priceLabel });
        }
        return bed;
    });
};
exports.setLowestPriceInfo = setLowestPriceInfo;
const sortBeds = (beds, reverse, selectedRoomCodes = [], selectedOfferCode = '', pinnedRooms = []) => {
    let matchedBeds = [];
    const nonMatchBeds = [];
    let matchPinned = [];
    let remainingBeds = [];
    beds.forEach(bed => {
        var _a;
        if (selectedRoomCodes.length) {
            if (bed.owsCode && selectedRoomCodes.includes(bed.owsCode)) {
                matchedBeds.push(bed);
            }
            else {
                nonMatchBeds.push(bed);
            }
        }
        else if (selectedOfferCode) {
            if ((_a = bed.offers) === null || _a === void 0 ? void 0 : _a.find(offer => offer.owsCode === selectedOfferCode)) {
                matchedBeds.push(bed);
            }
            else {
                nonMatchBeds.push(bed);
            }
        }
        else {
            nonMatchBeds.push(bed);
        }
    });
    if (pinnedRooms.length) {
        nonMatchBeds.forEach(bed => {
            if (pinnedRooms.includes(bed.roomPath)) {
                matchPinned.push(bed);
            }
            else {
                remainingBeds.push(bed);
            }
        });
    }
    else {
        remainingBeds = nonMatchBeds.map(bed => bed);
    }
    matchedBeds = sortBedsByPrice(matchedBeds);
    remainingBeds = sortBedsByPrice(remainingBeds);
    if (reverse) {
        matchedBeds = matchedBeds.reverse();
        remainingBeds = remainingBeds.reverse();
    }
    if (matchPinned.length) {
        matchPinned = matchPinned.sort((a, b) => {
            return pinnedRooms.indexOf(a.roomPath) - pinnedRooms.indexOf(b.roomPath);
        });
    }
    return matchedBeds.concat(matchPinned.concat(remainingBeds));
};
exports.sortBeds = sortBeds;
const sortBedsByPrice = (beds) => {
    return beds.sort((a, b) => {
        if (a.lowestPriceInfo) {
            if (b.lowestPriceInfo) {
                return (a.lowestPriceInfo.amount.withoutDecimal -
                    b.lowestPriceInfo.amount.withoutDecimal);
            }
            return -1;
        }
        return b.lowestPriceInfo ? 1 : 0;
    });
};
exports.sortBedsByPrice = sortBedsByPrice;
const sortOffers = (offers, reverse, ppMode, selectedOfferCode) => {
    let selectedOffer;
    let sortedOffers = [];
    const remainingOffers = [];
    offers.forEach(offer => {
        if (selectedOfferCode && offer.owsCode === selectedOfferCode) {
            sortedOffers.push(offer);
        }
        else {
            remainingOffers.push(offer);
        }
    });
    if (ppMode) {
        const ppOffers = sortOffersByPrice(remainingOffers.filter(offer => offer.ppOffer), reverse);
        const nonPpOffers = sortOffersByPrice(remainingOffers.filter(offer => !offer.ppOffer), reverse);
        sortedOffers = sortedOffers.concat(ppOffers.concat(nonPpOffers));
    }
    else {
        const localOffers = sortOffersByPrice(remainingOffers.filter(offer => offer.localMarketOnly), reverse);
        const nonLocalOffers = sortOffersByPrice(remainingOffers.filter(offer => !offer.localMarketOnly), reverse);
        sortedOffers = sortedOffers.concat(localOffers.concat(nonLocalOffers));
    }
    return sortedOffers;
};
exports.sortOffers = sortOffers;
const sortOffersByPrice = (offers, reverse) => {
    const sortedOffers = offers.sort((a, b) => {
        if (a.price) {
            if (b.price) {
                return a.price.amount.withoutDecimal - b.price.amount.withoutDecimal;
            }
            return -1;
        }
        return b.price ? 1 : 0;
    });
    if (reverse) {
        return sortedOffers.reverse();
    }
    return sortedOffers;
};
exports.sortOffersByPrice = sortOffersByPrice;
const setAccessibleOnly = (beds) => {
    return beds.map(bed => {
        if (bed.isAccessible === 'true') {
            if (!bed.owsCode) {
                if (filterBeds(beds, {
                    uniqueName: bed.uniqueName,
                    accessible: false,
                }).length) {
                    return Object.assign(Object.assign({}, bed), { accessibleOnly: true });
                }
            }
            else if (filterBeds(beds, {
                uniqueName: bed.uniqueName,
                accessible: false,
                bookDirect: false,
            }).length) {
                return Object.assign(Object.assign({}, bed), { accessibleOnly: true });
            }
        }
        return bed;
    });
};
exports.setAccessibleOnly = setAccessibleOnly;
const getAccommodationTypes = (beds, property, selectedOfferCode, selectedRoomCodes) => {
    var _a, _b;
    let accommodationTypes = [];
    const renamedTypes = [];
    (_b = (_a = property.customDisplayStep2) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.forEach(category => {
        if (category.title && !accommodationTypes.includes(category.title)) {
            if (filterBeds(beds, { accommodationType: category.title }).length) {
                accommodationTypes.push(category.title);
                if (category.naturalTitle && category.naturalTitle !== category.title) {
                    renamedTypes.push(category.naturalTitle);
                }
            }
        }
    });
    const bookableBeds = filterBeds(beds, { bookDirect: false });
    bookableBeds.forEach(bed => {
        if (bed.accommodationType &&
            !accommodationTypes.includes(bed.accommodationType) &&
            !renamedTypes.includes(bed.accommodationType)) {
            accommodationTypes.push(bed.accommodationType);
        }
    });
    if (selectedOfferCode || selectedRoomCodes) {
        const specificAvailableCategories = [];
        const specificNotAvailableCategories = [];
        accommodationTypes.forEach(category => {
            const categoryBeds = filterBeds(beds, { accommodationType: category });
            let availableInCategory = false;
            categoryBeds.forEach(bed => {
                var _a;
                if (!availableInCategory) {
                    if (selectedOfferCode) {
                        availableInCategory = !!((_a = bed.offers) === null || _a === void 0 ? void 0 : _a.find(offer => offer.owsCode === selectedOfferCode));
                    }
                }
                if (!availableInCategory) {
                    if (selectedRoomCodes && bed.owsCode) {
                        availableInCategory = selectedRoomCodes.includes(bed.owsCode);
                    }
                }
            });
            if (availableInCategory) {
                specificAvailableCategories.push(category);
            }
            else {
                specificNotAvailableCategories.push(category);
            }
            if (specificAvailableCategories.length && specificNotAvailableCategories.length) {
                accommodationTypes = specificAvailableCategories.concat(specificNotAvailableCategories);
            }
        });
    }
    const onRequestBeds = filterBeds(beds, { bookDirect: true });
    onRequestBeds.forEach(bed => {
        if (bed.accommodationType &&
            !accommodationTypes.includes(bed.accommodationType) &&
            !renamedTypes.includes(bed.accommodationType)) {
            accommodationTypes.push(bed.accommodationType);
        }
    });
    return accommodationTypes;
};
exports.getAccommodationTypes = getAccommodationTypes;
const getCustomAccommodationFilters = (property, options) => {
    var _a, _b, _c;
    const filters = Object.assign({}, options);
    if (!options.accommodationType) {
        return filters;
    }
    if (!((_b = (_a = property.customDisplayStep2) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.length)) {
        return filters;
    }
    const customAccommodationType = (_c = property.customDisplayStep2) === null || _c === void 0 ? void 0 : _c.categories.find(category => category.title === options.accommodationType);
    const pinnedRooms = [];
    if (customAccommodationType) {
        if (customAccommodationType.rooms && !options.bookDirect) {
            customAccommodationType.rooms.forEach(room => {
                if (room.path) {
                    pinnedRooms.push(room.path);
                }
            });
        }
        if (customAccommodationType.onRequestRooms && options.bookDirect !== false) {
            customAccommodationType.onRequestRooms.forEach(room => {
                if (room.path) {
                    pinnedRooms.push(room.path);
                }
            });
        }
        if (customAccommodationType.naturalTitle) {
            filters.accommodationType = customAccommodationType.naturalTitle;
        }
        if (pinnedRooms.length) {
            filters.customAccommodations = {
                accommodationType: filters.accommodationType,
                pinnedRooms,
            };
            delete filters.accommodationType;
        }
    }
    const excludedRooms = getCustomExcludedRooms(property, options.accommodationType, pinnedRooms);
    if (excludedRooms.length) {
        filters.excludedRooms = excludedRooms;
    }
    return filters;
};
exports.getCustomAccommodationFilters = getCustomAccommodationFilters;
const getCustomExcludedRooms = (property, accommodationType, pinnedRooms) => {
    var _a, _b, _c;
    const excludedRooms = [];
    if (!((_b = (_a = property.customDisplayStep2) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.length)) {
        return excludedRooms;
    }
    const otherCustomTypes = (_c = property.customDisplayStep2) === null || _c === void 0 ? void 0 : _c.categories.filter(category => category.title !== accommodationType);
    if (!otherCustomTypes.length) {
        return excludedRooms;
    }
    otherCustomTypes.forEach(customType => {
        var _a, _b;
        (_a = customType.rooms) === null || _a === void 0 ? void 0 : _a.forEach(room => {
            if (room.path && room.exclude === true && !pinnedRooms.includes(room.path)) {
                excludedRooms.push(room.path);
            }
        });
        (_b = customType.onRequestRooms) === null || _b === void 0 ? void 0 : _b.forEach(room => {
            if (room.path && room.exclude === true && !pinnedRooms.includes(room.path)) {
                excludedRooms.push(room.path);
            }
        });
    });
    return excludedRooms;
};
exports.getCustomExcludedRooms = getCustomExcludedRooms;
const filterBeds = (beds, filters) => {
    let filteredBeds = beds.map(bed => bed);
    if (!filters) {
        return filteredBeds;
    }
    if (filters.roomPath) {
        filteredBeds = filteredBeds.filter(bed => bed.roomPath === filters.roomPath);
    }
    if (filters.uniqueName) {
        filteredBeds = filteredBeds.filter(bed => bed.uniqueName === filters.uniqueName);
    }
    if (filters.accessible) {
        filteredBeds = filteredBeds.filter(bed => bed.isAccessible === 'true');
    }
    else if (filters.accessible === false) {
        filteredBeds = filteredBeds.filter(bed => !bed.isAccessible || bed.isAccessible !== 'true');
    }
    if (filters.accessibleOnly) {
        filteredBeds = filteredBeds.filter(bed => bed.accessibleOnly);
    }
    else if (filters.accessibleOnly === false) {
        filteredBeds = filteredBeds.filter(bed => !bed.accessibleOnly);
    }
    if (filters.bookDirect) {
        filteredBeds = filteredBeds.filter(bed => !bed.owsCode);
    }
    else if (filters.bookDirect === false) {
        filteredBeds = filteredBeds.filter(bed => !!bed.owsCode);
    }
    if (filters.accommodationType) {
        filteredBeds = filteredBeds.filter(bed => bed.accommodationType === filters.accommodationType);
    }
    if (filters.customAccommodations) {
        filteredBeds = filteredBeds.filter(bed => bed.accommodationType === filters.customAccommodations.accommodationType ||
            filters.customAccommodations.pinnedRooms.includes(bed.roomPath));
    }
    if (filters.excludedRooms) {
        filteredBeds = filteredBeds.filter(bed => !filters.excludedRooms.includes(bed.roomPath));
    }
    return filteredBeds;
};
exports.filterBeds = filterBeds;
const getPriceLabel = (allInPricing, geoIpCountryCode, resortFeesPricingCountries, taxes, taxesFeesCharges) => {
    if (!allInPricing) {
        return helpers_1.priceLabelAveragePerNight;
    }
    if (geoIpCountryCode && (resortFeesPricingCountries === null || resortFeesPricingCountries === void 0 ? void 0 : resortFeesPricingCountries.includes(geoIpCountryCode)) &&
        taxes &&
        taxesFeesCharges) {
        if (taxesFeesCharges.some(tax => {
            var _a;
            if (tax.code) {
                const propertyTax = (_a = taxes.taxes) === null || _a === void 0 ? void 0 : _a.find(taxItem => taxItem.taxID === tax.code);
                if (propertyTax && propertyTax.includeInRate) {
                    return true;
                }
            }
            return false;
        })) {
            return helpers_1.priceLabelAllInPricingFeesIncluded;
        }
    }
    return helpers_1.priceLabelAllInPricing;
};
